export default __webpack_public_path__ + "static/media/bk-hossain-logo.68e4a225.png";